<script lang="ts">
	import { run } from "svelte/legacy"

	import { ColorPickerStore, closeTagColorPicker } from "./TagColorPickerContext"
	import TagColorPickerPointer from "./TagColorPickerPointer.svelte"
	import { DataHandlerTag, PROJECTOR_COLOR_OPTIONS, type Tag } from "luxedo-data"
	import { Responsive } from "responsive"

	let isOpen = $state(false)
	let isMobile = $derived(Responsive.isMobile)

	let tag: Tag

	let initialLeft: number = $state()
	let initialTop: number = $state()
	let initialClickTop: number = $state()

	let actualLeft = $derived.by(() => {
		if (isMobile) return 8

		return initialLeft + 78
	})

	let actualTop = $derived.by(() => {
		if (isMobile) return initialTop + 36

		return initialTop - 28
	})

	let pointerTop = $derived.by(() => {
		if (isMobile) return -32

		return initialClickTop - initialTop + 20
	})

	let pointerLeft = $derived.by(() => {
		if (isMobile) return initialLeft
	})

	let colorPickerElem: HTMLDivElement = $state()

	ColorPickerStore.subscribe((ctx) => {
		isOpen = ctx.isOpen
		if (ctx.isOpen) {
			tag = ctx.tag
			initialTop = ctx.top
			initialLeft = ctx.left
			initialClickTop = ctx.top
		} else {
			tag = undefined
			initialTop = undefined
			initialLeft = undefined
		}
	})

	async function updateTrackColor(color: string) {
		tag.color = `#${color}`
		DataHandlerTag.save(tag)
		closeTagColorPicker()
	}

	function ensureBoundsWithinWindow() {
		const { bottom } = colorPickerElem.getBoundingClientRect()
		if (bottom > window.innerHeight) initialTop -= bottom - window.innerHeight + 16
	}

	run(() => {
		isOpen && colorPickerElem && ensureBoundsWithinWindow()
	})
</script>

{#if isOpen}
	<div class="bg-clear" onclick={closeTagColorPicker} onkeydown={undefined}></div>
	<div
		id="track-color-picker"
		class:isMobile
		bind:this={colorPickerElem}
		style="left: {actualLeft}px; top: {actualTop}px;"
	>
		{#each PROJECTOR_COLOR_OPTIONS as color}
			<div
				onclick={() => updateTrackColor(color)}
				class="color-option"
				style="background-color: #{color};"
				onkeydown={undefined}
			></div>
		{/each}
		<div
			id="track-color-point"
			style={`top: ${pointerTop}px; ${isMobile ? `left: ${pointerLeft}px` : ""}`}
		>
			<TagColorPickerPointer />
		</div>
	</div>
{/if}

<style>
	#track-color-picker {
		border: 1px solid var(--color-border);
		position: fixed;
		z-index: 102;
		backdrop-filter: blur(3rem);
		border-radius: var(--br);
		background-color: var(--color-bg);
		padding: 1rem;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
		grid-template-rows: 1fr 1fr 1fr 1fr;
		gap: 1rem;
	}

	#track-color-point {
		z-index: 101;
		position: fixed;
		width: 2rem;
		height: 2rem;
		border-radius: 1rem;
		backdrop-filter: blur(3rem);
		left: -1.75rem;
		/* top: 1rem; */
	}

	#track-color-point :global(svg) {
		width: 2rem;
		height: 2rem;
	}

	.color-option {
		cursor: pointer;
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 0.25rem;

		transition: transform 250ms;
	}

	.color-option:hover,
	.color-option:focus-visible {
		transform: scale(1.2);
	}

	.bg-clear {
		background-color: var(--color-bg);
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 100;
	}

	.isMobile #track-color-point {
		transform: rotate(90deg) translateX(4px);
	}
</style>
